import styled, { keyframes, css } from "styled-components";
import { portalColors } from "src/components";

export const RowContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};
    box-sizing: border-box;
    margin-bottom: 0.4375rem;
`;

export const Bubble = styled.div`
    position: relative;
    background: ${({ isMediaMessage, isFileMessage, isChatByCurrentUser }) => {
        if (isMediaMessage) return "transparent";
        if (isFileMessage) return "var(--calendar-surface-tertiary, #F0F0F0)";
        return isChatByCurrentUser ? "var(--calendar-action-primary-bg, #5B6EF5)" : portalColors.surface;
    }};
    color: ${({ isMediaMessage, isFileMessage, isChatByCurrentUser }) => {
        if (isMediaMessage) return "inherit";
        if (isFileMessage) return portalColors.text;
        return isChatByCurrentUser ? "var(--calendar-action-primary-text, #FFFFFF)" : portalColors.text;
    }};
    border-radius: ${({ borderRadius }) => borderRadius};
    padding: ${({ isMediaMessage, isFileMessage }) => {
        if (isMediaMessage) return "0";
        if (isFileMessage) return "0.7rem 1.25rem";
        return "0.7rem 1.25rem";
    }};
    box-shadow: ${({ isMediaMessage, isFileMessage }) =>
        isMediaMessage ? "none" : isFileMessage ? "0px 1px 5px rgba(0, 0, 0, 0.1)" : "0rem 0.0625rem 0.3125rem #0000000D"};
    height: auto;
    border: ${({ isMediaMessage, isFileMessage }) =>
        isMediaMessage ? "none" : isFileMessage ? "1px solid #808080" : "none"};

    width: fit-content;
    max-width: 28.1875rem;
    font-size: 1rem;
    font-weight: 500;
    box-sizing: border-box;
    line-height: 1.5;
    align-items: center;
    margin: 0;
    overflow-wrap: break-word;

    ${({ $failed }) =>
        $failed && css`
        border: 1px solid maroon;
        opacity: 0.5;
        filter: grayscale(10%) contrast(0.8);
    `}
`;

export const AvatarContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};
    align-items: center;
    margin: 0.75rem 0 0.625rem 0;
`;

export const AvatarName = styled.div`
    font-weight: 500;
    font-size: 0.8125rem;
    color: ${portalColors.text};
    margin: 0 0.5625rem;
`;

export const TimeStamp = styled.div`
    font-size: 0.8125rem;
    color: #AFBBC6;
    font-weight: 400;
    margin: 0.4375rem 0 0.230rem 0;
    display: ${({ display }) => display || "none"};
    flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};
    text-align: right;
`;

export const ClickableResendText = styled.span`
    text-decoration: underline;
    cursor: pointer;
`;

export const ReplyFromContainer = styled.div`
    & div.replyFromFullName {
        display: flex;
        flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};
        font-size: 0.75rem;
        color: var(--calendar-action-primary-bg, #5B6EF5);
    }

    & div.replyMessageContainer {
        display: flex;
        flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};
    }

    & div.replyFromMessage {
        background: var(--calendar-surface-tertiary, #DBE5ED);
        border-radius: ${p => p.isChatByCurrentUser ? "10px 10px 0px 10px" : "10px 10px 10px 0px"};
        color: var(--calendar-action-primary-bg, #5B6EF5);
        align-self: ${p => p.isChatByCurrentUser ? "end" : "start"};
        height: auto;
        width: fit-content;
        max-width: 28.1875rem;
        font-size: 1rem;
        font-weight: 500;
        padding: 0.7rem 1.25rem;
        box-sizing: border-box;
        line-height: 1.5;
        align-items: center;
        margin: 0;
        overflow-wrap: break-word;
    }
`;

export const EditedBadge = styled.div`
    font-size: 0.75rem;
    color: var(--calendar-action-primary-bg, #5B6EF5);
    margin-top: 0.25rem;
    display: inline-block;
    border-radius: 6px;
`;

export const EditedBadgeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${p => p.isChatByCurrentUser ? "flex-end" : "flex-start"};
`;

export const BubbleAndActionContainerElement = styled.div`
    display: flex;
    flex-direction: ${p => p.isChatByCurrentUser ? "row-reverse" : "row"};

    & div.ChatBubbleActions {
        display: flex;
        opacity: 0;
        align-items: center;
        position: relative;
    }

    &:hover div.ChatBubbleActions {
        opacity: 1;
    }

    & span.circle-radius {
        width: 20px;
        height: 20px;
        background: ${portalColors.surface};
        box-shadow: 0px 1px 5px #00000029;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 30px;
        margin: 0 3px;
        color: ${portalColors.textSoft};
        cursor: pointer;
    }

    & span.circle-radius :active {
        background-color: #DBE5ED;
    }
`;

export const DownloadWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const DownloadButton = styled.button`
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 6px #80808080;
    background: ${portalColors.surface};
    border: none;
    padding: 0;
    cursor: pointer;

    background-image: ${({ iconUrl }) => iconUrl ? `url("${iconUrl}")` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: 0.8rem 0.8rem;
`;

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    overflow-y: auto;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    max-width: 90vw;
    max-height: calc(90vh - 50px);
    min-height: 200px;
    background: #000;
    border-radius: 8px;
    box-shadow: 0 0 15px rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding-bottom: 0; /* Removed padding */

    img, video {
        max-width: 100%;
        max-height: 100%;
        display: block;
        border-radius: 8px;
        object-fit: contain;
    }
`;

export const MediaPreviewWrapper = styled.div`
    position: relative;
    width: ${({ width }) => width || "12rem"};
    height: ${({ height }) => height || "12rem"};
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
    background: ${p => p.background || "transparent"};
    padding: ${p => p.padding || "5px 10px"};
`;

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
`;

export const StyledImage = styled.img`
    width: ${p => p.width || "100%"};
    height: ${p => p.height || "100%"};
    max-width: ${p => p.maxWidth};
    max-height: ${p => p.maxHeight};
    object-fit: cover;
    display: block;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000029;

    ${({ $uploading }) =>
        $uploading && css`
        animation: ${pulse} 1.5s infinite;
    `}

    ${({ $failed }) =>
        $failed && css`
        border: 1px solid maroon;
        opacity: 0.5;
        filter: grayscale(10%) contrast(0.8);
    `}
`;

export const StyledVideo = styled.video`
    width: ${p => p.width || "100%"};
    height: ${p => p.height || "100%"};
    max-width: ${p => p.maxWidth};
    max-height: ${p => p.maxHeight};
    object-fit: cover;
    display: block;
    border-radius: 10px;

    ${({ $uploading }) =>
        $uploading && css`
        animation: ${pulse} 1.5s infinite;
    `}

    ${({ $failed }) =>
        $failed && css`
        border: 1px solid maroon;
        opacity: 0.5;
        filter: grayscale(10%) contrast(0.8);
    `}
`;

export const StyledFileIcon = styled.img`
    width: ${p => p.display || "20px"};
    height: ${p => p.height || "20px"};
    margin-right: ${p => p.marginRight || "8px"};
`;

export const QueuedMessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0 1rem;
    margin-bottom: 1rem;
`;

export const IsRead = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end; 
    font-size: 12px;
    color: #000000;
`;

export const IsReadFlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 300;
    font-family: Manrope;
`;

export const DecryptionNoticeButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border: 0;
    background: transparent;
    color: ${({ isChatByCurrentUser }) =>
        isChatByCurrentUser ? "#FFFFFF" : "#6C7680"};
    cursor: pointer;
    font-size: 0.875rem;
    font-style: italic;
    font-weight: 500;
    line-height: 1.4;
    padding: 0.2rem 0;
`;

export const DecryptionInfoBadge = styled.span`
    align-items: center;
    border: 1px solid #6C7680;
    border-radius: 50%;
    display: inline-flex;
    flex-shrink: 0;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 700;
    height: 1rem;
    justify-content: center;
    line-height: 1;
    width: 1rem;
`;

export const DecryptionDialogContent = styled.div`
    box-sizing: border-box;
    color: #20262B;
    max-width: 32rem;
    padding: 1.5rem;

    h3 {
        font-size: 1.125rem;
        margin: 0 0 0.75rem;
    }

    p {
        font-size: 0.9375rem;
        line-height: 1.5;
        margin: 0;
        white-space: pre-wrap;
    }
`;
